package dev.lingvo.site.components.studio.compose

/** PNG's IEEE CRC-32 over an explicitly bounded byte range. */
object Crc32 {
    private val table = IntArray(256) { value ->
        var crc = value
        repeat(8) { crc = if (crc and 1 != 0) (crc ushr 1) xor 0xEDB88320.toInt() else crc ushr 1 }
        crc
    }

    /** Returns the checksum bits as an [Int], including the final complement. */
    fun of(bytes: ByteArray, offset: Int = 0, length: Int = bytes.size - offset): Int {
        require(offset >= 0 && length >= 0 && offset <= bytes.size - length)
        var crc = -1
        for (index in offset until offset + length) {
            crc = table[(crc xor bytes[index].toInt()) and 255] xor (crc ushr 8)
        }
        return crc.inv()
    }
}
